import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import { useAuth } from 'react-oidc-context';
import { Condition, coonditionContext } from '../..';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";

interface LogoutDialogProps {
  // Change prop from 'open' to 'message'
  message: string | null | undefined; // Accept the message string or null
  onClose: () => void;
  hasBeenLoggedOut?: boolean
}

export const LogoutDialog: React.FC<LogoutDialogProps> = ({ message, onClose, hasBeenLoggedOut = false }) => {
  const auth = useAuth()
  const navigate = useNavigate()

  const { condition, baseName } = React.useContext<Condition>(coonditionContext);
  // Determine if the dialog should be open based on the message prop
  const isOpen = Boolean(message);
  // Effect to auto-close the dialog after 30 seconds, now based on logoutMessage
  React.useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    timer = setTimeout(() => {
      onClose()
    }, 60000); // 30 seconds
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);
  return (
    <Dialog
      // Use the derived isOpen state for the open prop
      open={isOpen}
      onClose={onClose}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
    >
      <DialogTitle id="logout-dialog-title">
        Oops! Something went sideways with your session
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="logout-dialog-description">
          {hasBeenLoggedOut && "We've logged you out to be safe."}
          {message && (
          <Accordion key="accordion" sx={{ mt: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">More Info</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {message}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )}
          <Typography sx={{ mt: 4, mb: 2} }> If the problem persists, please contact <a href="mailto:contact@polygonhealth.com">contact@polygonhealth.com</a>.</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button key="signin" variant="contained" sx={{ color: 'white', backgroundColor: '#656EFF', borderRadius: 8, border: '1px solid', borderColor: '#656EFF' }} onClick={() => {
          // It's a good practice to clear any stale OIDC state before initiating a new login.
          auth.clearStaleState();
          navigate('/signin')
        }} disableElevation >
          Sign in
        </Button>
        <Button  key="close" variant="contained" sx={{ color: '#656EFF', backgroundColor: 'white', borderRadius: 8,    border: '1px solid', borderColor: '#656EFF' }} onClick={onClose} disableElevation>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};